import { useRoutes } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";

import { MatxTheme } from "./components";
import SettingsProvider from "./hooks/contexts/SettingsContext";
import routes from "./routes";
import "../fake-db";
import AuthProvider from "./hooks/contexts/AuthProvider";
import { ToastContainer } from "react-toastify";
import { LoadingProvider } from "./hooks/contexts/LoadingContext";
import { SearchFiltersProvider } from "./hooks/contexts/SearchFiltersContext";

export default function App() {
  
  const content = useRoutes(routes);

  return (
    <AuthProvider>
      <SettingsProvider>
        <SearchFiltersProvider>
          <LoadingProvider>
            <MatxTheme>
              <CssBaseline />
              {content}
              <ToastContainer />
            </MatxTheme>
          </LoadingProvider>
        </SearchFiltersProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
